import { useState } from 'react'
import type { ChangeEvent } from 'react'
import { TextInput } from '@ztechapps/webui.input'

export type PromptContentProps = {
  defaultValue?: string
  onValueChange: (value: string) => void
}

export const PromptContent = ({ defaultValue = '', onValueChange }: PromptContentProps) => {
  const [value, setValue] = useState(defaultValue)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setValue(newValue)
    onValueChange(newValue)
  }

  return <TextInput value={value} onChange={handleChange} autoFocus placeholder="Enter value..." />
}
